document.addEventListener('DOMContentLoaded', () => {
  const theses = document.querySelectorAll('[data-thesis-title]');

  theses.forEach((title) => {
    const section = title.closest('.lh-landings-thesis');
    if (!section) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
          section.classList.add('is-visible');
          observer.disconnect();
        }
      });
    }, { threshold: [0, 0.3, 1] });

    observer.observe(section);
  });
});
